import { render, staticRenderFns } from "./assignSiteDialog.vue?vue&type=template&id=1b84f3d5&scoped=true"
import script from "./assignSiteDialog.vue?vue&type=script&lang=js"
export * from "./assignSiteDialog.vue?vue&type=script&lang=js"
import style0 from "./assignSiteDialog.vue?vue&type=style&index=0&id=1b84f3d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b84f3d5",
  null
  
)

export default component.exports